import React from 'react';
import { useTrackPageEngagement } from './hooks';

interface IProps {
  componentName: string;
}
export const TrackEngagement = (props: React.PropsWithChildren<IProps>) => {
  const { children, componentName } = props;
  const track = useTrackPageEngagement(componentName);

  return (
    <div onMouseOver={track} onFocus={track}>
      {children as React.ReactElement<any>}
    </div>
  );
};
